import type { URLParams } from '../../types';
import { Logger } from '../../utils';

export interface RouteDecision {
  route: 'landing' | 'survey' | 'documentation';
  shouldInitialize: boolean;
}

export class RouterService {
  static determineRoute(urlParams: URLParams, currentPath: string, currentHash: string): RouteDecision {
    // Documentation route
    if (currentPath === '/doc' || currentHash === '#doc') {
      return { route: 'documentation', shouldInitialize: false };
    }

    // Landing page route (no survey parameters)
    if (!urlParams.userId && !urlParams.surveyId && !urlParams.anonymous) {
      return { route: 'landing', shouldInitialize: false };
    }

    // Survey route (has parameters)
    return { route: 'survey', shouldInitialize: true };
  }

  static async loadLandingPage(): Promise<void> {
    try {
      const response = await fetch('/landing.html');
      const html = await response.text();
      
      // Parse the HTML to extract head and body content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extract and inject head content (styles, meta tags, etc.)
      const headContent = doc.head.innerHTML;
      const bodyContent = doc.body.innerHTML;
      
      // Add landing page styles to current document head
      const existingStyles = document.head.querySelector('style[data-landing-page]');
      if (existingStyles) {
        existingStyles.remove();
      }
      
      // Create a style element to hold the landing page styles
      const styleElement = document.createElement('div');
      styleElement.innerHTML = headContent;
      const landingStyles = styleElement.querySelector('style');
      
      if (landingStyles) {
        landingStyles.setAttribute('data-landing-page', 'true');
        document.head.appendChild(landingStyles);
      }
      
      // Replace body content
      document.body.innerHTML = bodyContent;
      
      // Add landing class to html element (for our CSS overrides)
      document.documentElement.className = 'landing';
      
    } catch (error) {
      Logger.error('Failed to load landing page:', error);
      throw new Error('Could not load landing page');
    }
  }
}